import React, { useState, useEffect } from 'react';
import moment from "moment";

import * as apiAdmin from "../../../../api/apiAdmin"
import { Pagination } from '../../Res/Pagination';
import { ReqClientAdminListPage } from '../../../../item/ItemAccount';
import { ContentBox } from '../../Content/ContentBox';
import { AddButton, SearchButton, EnableBadge, DisableBadge, CancelButton } from '../../Res/BaseButton';
import { SystemPromptInput } from '../../Res/SystemPrompt';

export function ClientAdminList({pageId}) {
  const [clientAdminList, setClientAdminList] = useState([])
  const [page, setPage] = useState(1)
  const [limit] = useState(10)
  const [count, setCount] = useState(0)
  const [disableCount, setDisableCount] = useState(0)
  const [enableCount, setEnableCount] = useState(0)

  const [mobile, setMobile] = useState("")
  const [nickName, setNickName] = useState("")
  const [status, setStatus] = useState(-1)

  var title = '申請人列表'
  var content =
    <>
      <div className="row">
        <div className="col-sm-12">
          <EnableBadge count={enableCount} />
          <DisableBadge count={disableCount} />
          <AddButton name={"新增"} action={toAdd} />
        </div>
      </div>
      <div className="row m-b-sm">
      </div>
      <ManagerListBox managerList={clientAdminList} sml={setClientAdminList} count={count} page={page} sp={setPage} />
    </>

  var precautionsInfo = <>顯示</>



  useEffect(() => {
    if (clientAdminList.length === 0) {
      getClientAdminList()
    }
  }, [])
  

  function getClientAdminList() {
    console.log("getManagerList")
    var start = (page - 1) * limit;
    var mReqClientAdminListPage = new ReqClientAdminListPage({ start, limit })
    apiAdmin.getClientAdminListPage({
      mReqClientAdminListPage,
      success: (obj) => {
        console.log(obj)
        setClientAdminList(obj.list)
        setCount(obj.count)
        setDisableCount(obj.disableCount)
        setEnableCount(obj.enableCount)
      },
      failure: (err) => {
        console.log(err)
        //window.location.replace("/AdminManagerList");
      }
    })
  }

  function toAdd() {
    window.location.assign("/ClientAdminAdd");
  }

  function toCelar(){
    setMobile("")
    setNickName("")
    setStatus(-1)
  }

  function toSearch() {
    console.log(mobile)
    console.log(nickName)
    console.log(status)
  }

  return (
    <>
    {/**
      <ManagerListSearch m={mobile} sm={setMobile} n={nickName} sn={setNickName} s={status} ss={setStatus} toC={toCelar} toS={toSearch} />
     */}
      <ContentBox title={title} content={content} hasDrawer={true} />
      <SystemPromptInput />
      {/**
      <Precautions precautionsInfo={precautionsInfo} hasDrawer={true} defaultHideDrawer={false} />
       */}
    </>
  )
}

function ManagerListSearch({m, sm, n, sn, s, ss, toC, toS}) {
  const [mobile, setMobile] = useState(m)
  const [nickName, setNickName] = useState(n)
  const [status, setStatus] = useState(s)

  useEffect(()=>{
    if(m !== mobile){
      setMobile(m)
    }
  },[m])

  useEffect(()=>{
    if(n !== nickName){
      setNickName(n)
    }
  },[n])

  useEffect(()=>{
    if(s !== status){
      setStatus(s)
    }
  },[s])

  var content =
  <>
    <div className="row">
      <div className="col-sm-4">
        <p>
          以帳號搜尋
          </p>
        <input type="text" className="form-control required" value={mobile} onChange={e=>sm(e.target.value)} />
      </div>

      <div className="col-sm-4">
        <p>
          以暱稱搜尋
          </p>
        <input type="text" className="form-control required" value={nickName} onChange={e=>sn(e.target.value)} />
      </div>
      <div className="col-sm-4">
        <p>
          狀態
          </p>
        <select className="select2_demo_1 form-control" value={status} onChange={e=>ss(e.target.value)}>
          <option value="-1">全部</option>
          <option value="0">啟用</option>
          <option value="1">停用</option>
        </select>
      </div>

    </div>
      <div className="row m-t-sm m-t-sm">
        <div className="col-sm-4 col-sm-offset-5">
          <CancelButton name={"清除"} action={toC} />
          <SearchButton action={toS} />
        </div>
      </div>
  </>
  return (
    <ContentBox hasTitle={false} content={content} hasDrawer={true} />
  )
}

function ManagerListBox({ managerList, sml, count, page, sp }) {
  const [mManagerList, setManagerList] = useState([])
  const [mPage, setPage] = useState(1)
  const [limit] = useState(10)
  const [mCount, setCount] = useState(0)

  useEffect(() => {
    if (managerList !== undefined && mManagerList !== managerList) {
      setManagerList(managerList)
      setPage(page)
    }

    if(count !== mCount){
      setCount(count)
    }
  })

  function sPage(p) {
    console.log("pagechange" + page)
    if (p !== page) {
      sp(p)
      setPage(p)
    }
  }

  if (mManagerList.length === 0) {
    return (<></>)
  } else {
    //console.log(managerList)
    return (
      <div id="editable_wrapper" className="form-inline dt-bootstrap">
        <div className="row">
          <div className="col-sm-12">
            <table className="table table-striped table-bordered table-hover  dataTable">
              <thead>
                <tr role="row">
                  <th className="text-center sorting col-sm-4">帳號</th>
                  <th className="text-center sorting col-sm-4">暱稱</th>
                  <th className="text-center sorting col-sm-2">公司數</th>
                  <th className="text-center sorting col-sm-2">狀態</th>
                </tr>
              </thead>
              <tbody>
                {
                  mManagerList.map((manager) => (
                    <ManagerBox key={manager.mobile} manager={manager} />
                  ))
                }
              </tbody>
            </table>
          </div>
        </div>
        {
          mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} />
        }
      </div>
    )
  }

}

function ManagerBox({ manager }) {
  const [account, setAccount] = useState(manager)

  if (account !== manager) {
    setAccount(manager)
  }

  function toCompanyList() {
    window.location.assign("/ClientAdminDetail/" + account.accountId);
  }

  var creatAt = moment(new Date(account.creatAt)).format("YYYY-MM-DD HH:mm:ss");
  var avatar = <img className="img-circle" src="/img/a3.jpg" alt="User profile" />
  if (account.avatar !== "") {
    avatar = <img className="img-circle" src={account.avatar} alt="User profile" />
  }
  var status = "<></>";

  if (account.isDisable === 1) {
    status = <span className="text-danger">停用</span>
  } else {
    status = <span className="text-info">啟用</span>
  }

  return (
    <tr role="row">
      <td className="text-center"><a href="#A" onClick={toCompanyList}>{account.mobile}</a></td>
      <td className="text-center">{account.nickName}</td>
      <td className="text-center"><span>{account.companyCount}</span></td>
      <td className="text-center"><span>{status}</span></td>
    </tr>
  )
  /**
   * 
    <tr>
      <td>
        <div className="feed-element">
          {avatar}
        </div>
      </td>
      <td style={{ verticalAlign: "middle" }}><div>{account.mobile}</div></td>
      <td style={{ verticalAlign: "middle" }}>{account.nickName}</td>
      <td style={{ verticalAlign: "middle" }}>{account.email}</td>
      <td style={{ verticalAlign: "middle" }}>{status}</td>
      <td style={{ verticalAlign: "middle" }}>{creatAt}</td>
      <td style={{ verticalAlign: "middle" }}>
        <a href="#A" className="btn btn-social-icon btn-linkedin" onClick={toCompanyList}><i className="fa fa-eye"></i></a>
      </td>
    </tr>
   */
}
